/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-03-13 15:22:48
 *
 *******************************************************/
// @flow

import _ from 'lodash';

import React, { Component } from 'react';
import { Line } from 'react-chartjs-2';

import {
  PRIMARY_DATASET_LINE_OPTIONS,
  COMPARED_DATASET_LINE_OPTIONS,
  CHART_OPTIONS
} from 'src/constants/analytics';
import {
  displayDateRange,
  buildCompareDateRange,
  prepareDateLabelAxesOnChart
} from 'src/helpers/analytics-helpers';
import { customTooltip } from 'src/constants/analytics';
import { formatNumberWithMoney } from 'src/helpers';

type Props = {
  type: string,
  fromDate: Object,
  toDate: Object,
  compare: boolean,
  source: Array<Object>,
  comparedSource: Array<Object>
};
// DONE
class AnalyticsChart extends Component<Props> {
  render() {
    const {
      fromDate,
      toDate,
      compare,
      source,
      comparedSource,
      title,
      isMoneyFormat = false
    } = this.props;
    // Get chart data
    let arrSource = source.map(item => {
      return item.total;
    });
    let arrComparedSource = comparedSource.map(item => {
      return item.total;
    });

    // Get chart labels
    const labels = source.map(item => {
      return item.datetime;
    });

    const data = compare
      ? {
          labels,
          datasets: [
            _.merge(
              { ...COMPARED_DATASET_LINE_OPTIONS },
              {
                label: buildCompareDateRange(fromDate, toDate),
                data: arrComparedSource
              }
            ),
            _.merge(
              { ...PRIMARY_DATASET_LINE_OPTIONS },
              {
                label: displayDateRange(fromDate, toDate),
                data: arrSource
              }
            )
          ]
        }
      : {
          labels,
          datasets: [
            _.merge(
              { ...PRIMARY_DATASET_LINE_OPTIONS },
              {
                label: displayDateRange(fromDate, toDate),
                data: arrSource
              }
            )
          ]
        };

    const options = _.merge(
      { ...CHART_OPTIONS },
      {
        tooltips: customTooltip(source, comparedSource, compare, isMoneyFormat),
        scales: {
          xAxes: [
            {
              ticks: {
                callback: function (label, index, labels) {
                  return prepareDateLabelAxesOnChart(label);
                }
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                callback: function (label, index, labels) {
                  const value = label > 1000 ? label / 1000 + 'k' : label;
                  return isMoneyFormat
                    ? formatNumberWithMoney(value).replace(/<[^>]*>?/gm, '')
                    : value;
                }
              }
            }
          ]
        }
      }
    );
    return (
      <div style={{ marginTop: '0.625rem' }}>
        <div
          style={{
            fontSize: '0.75rem',
            lineHeight: '16px',
            fontWeight: 600,
            textTransform: 'uppercase',
            marginBottom: '-0.75rem'
          }}>
          {title}
          <span>&nbsp;</span>
        </div>
        <Line data={data} options={options} />
      </div>
    );
  }
}

export default AnalyticsChart;
